export default __webpack_public_path__ + "c53d8ad4a08e064427efb962bc6ef42b.webp";